var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgClose from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
/**
 * Create component class
 */
var DialogTitleComponent = /** @class */ (function (_super) {
    __extends(DialogTitleComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function DialogTitleComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            contain: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
            },
            title: {
                color: 'rgba(0,0,0,0.87)',
                flex: '1 1',
                font: '500 20px Roboto,RobotoDraft,Helvetica,Arial,sans-serif'
            }
        };
        // Defaul state
        _this.state = {};
        return _this;
        // Binding functions to `this`
    }
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    DialogTitleComponent.prototype.render = function () {
        var _a = this.props, buttonLabel = _a.buttonLabel, disabledButton = _a.disabledButton, onClickButton = _a.onClickButton, onRequestClose = _a.onRequestClose, title = _a.title;
        return (React.createElement("div", { className: 'g__dialog-title' },
            React.createElement("div", { style: this.styles.contain },
                React.createElement("div", { style: { paddingRight: '10px' } },
                    React.createElement(SvgClose, { onClick: onRequestClose, style: { cursor: 'pointer' } })),
                React.createElement("div", { style: this.styles.title }, title || ''),
                buttonLabel ? (React.createElement("div", { style: { marginTop: '-9px' } },
                    React.createElement(Button, { color: 'primary', disabled: disabledButton ? disabledButton : false, onClick: onClickButton || (function (x) { return x; }) },
                        " ",
                        buttonLabel || '',
                        " "))) : ''),
            React.createElement(Divider, null)));
    };
    DialogTitleComponent.propTypes = {
        /**
         * The label of right button
         */
        buttonLabel: PropTypes.string,
        /**
         * If it's true button will be disabled
         */
        disabledButton: PropTypes.bool,
        /**
         * Call the funtion the time is clicked on right button
         */
        onClickButton: PropTypes.func,
        /**
         * The function will be called the time is clicked on close
         */
        onRequestClose: PropTypes.func.isRequired,
        /**
         * The title of dialog box
         */
        title: PropTypes.string
    };
    return DialogTitleComponent;
}(Component));
export default DialogTitleComponent;



//////////////////
// WEBPACK FOOTER
// ./src/layouts/dialogTitle/DialogTitleComponent.tsx
// module id = 1474
// module chunks = 0 1 2 3 5